import { isJobCategory } from "@/domains/job-offer/create/constants";
import type { InitialState } from "../store/freelance-search-store";

/**
 * Drops `job_category` from search filters when it is not one of the 8
 * categories (a value saved or put in a URL before the release). Filters
 * without a category, or with a valid one, are returned unchanged.
 */
export function withoutRemovedCategory<
  T extends { job_category?: string; [filter: string]: unknown } | null,
>(filters: T): T {
  if (!filters || filters.job_category === undefined) return filters;
  if (isJobCategory(filters.job_category)) return filters;
  const { job_category: _removed, job_subcategory: _subs, ...rest } = filters;
  return rest as T;
}

/**
 * `deserialize` of the persisted search store: cleans both filter objects the
 * proposal form can prefill from (`proposalPreFillFilters`, and
 * `initialResultFilters` as its fallback).
 */
export function deserializeFreelanceSearchState(raw: string): InitialState {
  const state: InitialState = JSON.parse(raw);
  return {
    ...state,
    proposalPreFillFilters: withoutRemovedCategory(
      state.proposalPreFillFilters,
    ),
    initialResultFilters: withoutRemovedCategory(state.initialResultFilters),
  };
}
